import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ui-wish.png'


const _withScopeId = n => (_pushScopeId("data-v-60509e75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "navbar" }
const _hoisted_5 = { class: "loaded-content" }

import { Banner } from "@/types";
import { Ref, ref } from "vue";
import BookOverlay from "../overlays/BookOverlay.vue";
import BannerStylisedText from "./BannerStylisedText.vue";
import BannerDetailsDropRates from "./BannerDetailsDropRates.vue";
import BannerDetailsText from "./BannerDetailsText.vue";
import BannerDetailsItemList from "./BannerDetailsItemList.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    banner: null
  },
  emits: ["exit"],
  setup(__props: any, { emit }: { emit: ({ (e: "exit"): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { banner: Banner }




const isStandardBanner = props.banner.featuredDrops.length === 0;
const navSelected: Ref<"items" | "details" | "drops"> = ref(
  isStandardBanner ? "details" : "items"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BookOverlay, {
    onExit: _cache[3] || (_cache[3] = ($event: any) => (emit('exit')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(_toDisplayString(isStandardBanner ? "Standard" : "Event") + " Wish ", 1),
          _createVNode(BannerStylisedText, {
            banner: __props.banner,
            quotes: true
          }, null, 8, ["banner"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (!isStandardBanner)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{ selected: navSelected.value === 'items' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (navSelected.value = 'items'))
              }, " Promotional Items ", 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([{ selected: navSelected.value === 'details' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (navSelected.value = 'details'))
          }, " Details ", 2),
          _createElementVNode("div", {
            class: _normalizeClass([{ selected: navSelected.value === 'drops' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (navSelected.value = 'drops'))
          }, " List of Items ", 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createVNode(BannerDetailsDropRates, { banner: __props.banner }, null, 8, ["banner"]), [
            [_vShow, navSelected.value === 'items']
          ]),
          _withDirectives(_createVNode(BannerDetailsText, { banner: __props.banner }, null, 8, ["banner"]), [
            [_vShow, navSelected.value === 'details']
          ]),
          _withDirectives(_createVNode(BannerDetailsItemList, { banner: __props.banner }, null, 8, ["banner"]), [
            [_vShow, navSelected.value === 'drops']
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})